var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "InstagramLogo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11 14.4375C12.8985 14.4375 14.4375 12.8985 14.4375 11C14.4375 9.10152 12.8985 7.5625 11 7.5625C9.10152 7.5625 7.5625 9.10152 7.5625 11C7.5625 12.8985 9.10152 14.4375 11 14.4375Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.7812 3.09375H7.21875C4.94058 3.09375 3.09375 4.94058 3.09375 7.21875V14.7812C3.09375 17.0594 4.94058 18.9062 7.21875 18.9062H14.7812C17.0594 18.9062 18.9062 17.0594 18.9062 14.7812V7.21875C18.9062 4.94058 17.0594 3.09375 14.7812 3.09375Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.4688 7.21875C15.8484 7.21875 16.1562 6.91095 16.1562 6.53125C16.1562 6.15155 15.8484 5.84375 15.4688 5.84375C15.0891 5.84375 14.7812 6.15155 14.7812 6.53125C14.7812 6.91095 15.0891 7.21875 15.4688 7.21875Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramLogo);
export default __webpack_public_path__ + "static/media/instagramLogo.05bb98c6094e0858090c32125639dc72.svg";
export { ForwardRef as ReactComponent };